/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tasks_Retry_FailedInputs */

const en_tasks_retry_failed = /** @type {(inputs: Tasks_Retry_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Re-run failed`)
};

const fr_tasks_retry_failed = /** @type {(inputs: Tasks_Retry_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Relance échouée`)
};

const ms_sg2_tasks_retry_failed = /** @type {(inputs: Tasks_Retry_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pelancaran semula gagal`)
};

/**
* | output |
* | --- |
* | "Re-run failed" |
*
* @param {Tasks_Retry_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const tasks_retry_failed = /** @type {((inputs?: Tasks_Retry_FailedInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tasks_Retry_FailedInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tasks_retry_failed(inputs)
	if (locale === "fr") return fr_tasks_retry_failed(inputs)
	return ms_sg2_tasks_retry_failed(inputs)
});